import { localizedText } from "../helpers/localization"
import { Controller } from "@hotwired/stimulus"

const RESET_DELAY = 2000

export default class extends Controller {
  static targets = ["tag", "filterButton", "copyAllButton"]
  static values = { filter: { type: String, default: "all" } }

  connect() {
    this.#applyFilter(this.filterValue)
  }

  filter(event) {
    const key = event.currentTarget.dataset.tagExtractorFilter
    this.filterValue = key
    this.#applyFilter(key)

    this.filterButtonTargets.forEach((btn) => {
      btn.classList.toggle("stub-primary-soft", btn.dataset.tagExtractorFilter === key)
      btn.classList.toggle("border", btn.dataset.tagExtractorFilter === key)
      btn.classList.toggle("stub-muted", btn.dataset.tagExtractorFilter !== key)
    })
  }

  async copy(event) {
    event.preventDefault()
    const text = event.currentTarget.dataset.tag
    if (!text) return

    await navigator.clipboard.writeText(text)
    const label = event.currentTarget.querySelector("[data-copy-label]")
    if (label) {
      const original = label.textContent
      label.textContent = localizedText(this.element, "copied")
      clearTimeout(this.resetTimer)
      this.resetTimer = setTimeout(() => { label.textContent = original }, RESET_DELAY)
    }
  }

  async copyAll() {
    const visibleTags = this.tagTargets
      .filter((el) => !el.classList.contains("hidden"))
      .map((el) => el.dataset.tag)

    if (!visibleTags.length) return

    await navigator.clipboard.writeText(visibleTags.join(", "))

    if (this.hasCopyAllButtonTarget) {
      const original = this.copyAllButtonTarget.textContent
      this.copyAllButtonTarget.textContent = localizedText(this.element, "copied")
      clearTimeout(this.copyAllTimer)
      this.copyAllTimer = setTimeout(() => {
        this.copyAllButtonTarget.textContent = original
      }, RESET_DELAY)
    }
  }

  disconnect() {
    clearTimeout(this.resetTimer)
    clearTimeout(this.copyAllTimer)
  }

  // ── private ─────────────────────────────────────────────────────────────

  #applyFilter(key) {
    this.tagTargets.forEach((el) => {
      const group = el.dataset.tagGroup
      const show = key === "all" || !group || group === key
      el.classList.toggle("hidden", !show)
    })
  }
}
